import Interceptor from "@/plugins/interceptor";
import PSCommon from "@/plugins/ps.common";
const urlAPI = `${process.env.VUE_APP_URL_API}/neighregistration`;

const rent = {
  state: {
    rentModel: {
      UnitId: null,
      ContractType: null,
      ContractDateFrom: "",
      ContractDateTo: "",
      Titulars: [
        {
          FirstName: "",
          LastName: "",
          Email: "",
          Phone: "",
          IdentificationTypeId: "",
          Identification: "",
          PersonTypeId: "1",
          CUIL: "",
          UniqueCode: PSCommon.createGuid(),
          RelatedLegalTitular: "",
        },
      ],
    },
  },
  actions: {
    addTitularRent({ commit }) {
      commit("ADD_TITULAR_RENT", {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        IdentificationTypeId: "",
        Identification: "",
        PersonTypeId: "1",
        CUIL: "",
        UniqueCode: PSCommon.createGuid(),
        RelatedLegalTitular: "",
      });
    },
    createRentProcedure({ state }) {
      state.rentModel.UnitId = Number(state.rentModel.UnitId);
      state.rentModel.ContractType = Number(state.rentModel.ContractType);
      state.rentModel.Titulars.map((titular) => {
        titular.IdentificationTypeId = Number(titular.IdentificationTypeId);
        titular.PersonTypeId = Number(titular.PersonTypeId);
      });
      Interceptor.post(`${urlAPI}/createrentprocedure`, state.rentModel).then(
        () => {
          window.mainApp.$router.push("/vecino/successProcedure");
        }
      );
    },
    removeTitularRent({ commit }, index) {
      commit("REMOVE_TITULAR_RENT", index);
    },
  },
  mutations: {
    ADD_TITULAR_RENT(state, value) {
      state.rentModel.Titulars.push(value);
    },
    REMOVE_TITULAR_RENT(state, value) {
      state.rentModel.Titulars.splice(value, 1);
    },
  },
};

const sell = {
  state: {
    sellModel: {
      UnitId: null,
      Titulars: [
        {
          FirstName: "",
          LastName: "",
          Email: "",
          Phone: "",
          IdentificationTypeId: "",
          Identification: "",
          PersonTypeId: "1",
          CUIL: "",
          UniqueCode: PSCommon.createGuid(),
          RelatedLegalTitular: "",
        },
      ],
    },
  },
  actions: {
    addTitularSell({ commit }) {
      commit("ADD_TITULAR_SELL", {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        IdentificationTypeId: "",
        Identification: "",
        PersonTypeId: "1",
        CUIL: "",
        UniqueCode: PSCommon.createGuid(),
        RelatedLegalTitular: "",
      });
    },
    createSellProcedure({ state }) {
      state.sellModel.UnitId = Number(state.sellModel.UnitId);
      state.sellModel.Titulars.map((titular) => {
        titular.IdentificationTypeId = Number(titular.IdentificationTypeId);
        titular.PersonTypeId = Number(titular.PersonTypeId);
      });
      Interceptor.post(`${urlAPI}/createsellprocedure`, state.sellModel).then(
        () => {
          window.mainApp.$router.push("/vecino/successProcedure");
        }
      );
    },
    removeTitularSell({ commit }, index) {
      commit("REMOVE_TITULAR_SELL", index);
    },
  },
  mutations: {
    ADD_TITULAR_SELL(state, value) {
      state.sellModel.Titulars.push(value);
    },
    REMOVE_TITULAR_SELL(state, value) {
      state.sellModel.Titulars.splice(value, 1);
    },
  },
};

const procedure = {
  state: {
    ModelProcedure: {},
  },
  actions: {
    getProcedure({ commit }, params) {
      return new Promise((resolve, reject) => {
        Interceptor.get(`${urlAPI}/procedure/${params.ucode}`)
          .then((res) => {
            commit("SET_PROCEDURE", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateProcedure({ commit }, params) {
      return new Promise((resolve, reject) => {
        Interceptor.post(`${urlAPI}/updateprocedure`, params.model)
          .then((res) => {
            resolve(res.data);
            commit("SET_PROCEDURE", res.data);
          })
          .catch((err) => {
            if (process.env.NODE_ENV !== 'production') {
              // eslint-disable-next-line no-console
              console.warn('[updateProcedure] error', err && err.response && err.response.data);
            }
            reject(err);
          });
      });
    },

    updatePartner({ commit }, params) {
      commit("UPDATE_PARTNER", params.ownerSpouseId);
    },

    getResidentByDni({ commit, state }, { typeId, identification, idx }) {
      return new Promise((resolve, reject) => {
        Interceptor.get(`${urlAPI}/procedure/resident?dni=${identification}&identificationTypeId=${typeId}`)
          .then((res) => {
            const data = res.data;
            if (data && Object.keys(data).length > 0) {

              const apiResident = Object.fromEntries(
                // eslint-disable-next-line no-unused-vars
                Object.entries(data).filter(([_, v]) => v != null)
              );

              const current = (state.ModelProcedure.Resident && state.ModelProcedure.Resident[idx]) || {};

              const defaults = {
                Id: 0,
                Name: "",
                LastName: "",
                DateOfBirth: "",
                MaritalStatusId: 0,
                IdentificationTypeId: typeId,
                Identification: identification,
                ResidentTypeId: "",
                School: "",
                IdFront: 0,
                IdBack: 0,
                IdRecurrence: 0,
                IdResidence: 0,
                IdFacialRecognition: 0,
              };

              const merged = {
                ...defaults,
                ...current,
                ...apiResident,
                IdentificationTypeId: typeId,
                Identification: identification,
              };

              if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.log(`[getResidentByDni] dni=${identification} IsResident=${merged.IsResident}`);
              }

              resolve(merged);
              commit("UPDATE_RESIDENT", { resident: merged, idx });
            } else {
              if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.warn(`[getResidentByDni] respuesta vacia para dni=${identification}`);
              }
              reject("'getResidentByDni' data error...!");
            }
          })
          .catch((err) => {
            if (process.env.NODE_ENV !== 'production') {
              // eslint-disable-next-line no-console
              console.warn(`[getResidentByDni] error dni=${identification}`, err && err.response && err.response.data);
            }
            reject(err);
          });
      });
    },

    addResident({ commit }) {
      commit("ADD_RESIDENT", {
        Id: 0,
        Name: "",
        LastName: "",
        DateOfBirth: "",
        MaritalStatusId: 0,
        IdentificationTypeId: "",
        Identification: "",
        ResidentTypeId: "",
        School: "",
        IdFront: 0,
        IdBack: 0,
        IdRecurrence: 0,
        IdResidence: 0,
        IdFacialRecognition: 0,
      });
    },

    removeResident({ commit }, index) {
      commit("REMOVE_RESIDENT", index);
    },

    addReference({ commit }) {
      commit("ADD_REFERENCE", {
        Id: 0,
        Name: "",
        LastName: "",
        Profession: "",
        WorkActivity: "",
        PhoneNumber: "",
        StreetName: "",
        StreetNumber: "",
        PostCode: "",
        Floor: "",
        Department: "",
        City: "",
        StateId: 0,
        IsOwner: true,
        NeighborhoodId: 0,
        Unit: "",
      });
    },

    removeReference({ commit }, index) {
      commit("REMOVE_REFERENCE", index);
    },

    addVehicle({ commit }) {
      commit("ADD_VEHICLE", {
        Domain: "",
        Brand: "",
        Model: "",
        Year: "",
        Color: "",
        RelatedPersonUniqueCode: "",
        IdentificationCardFront: 0,
        IdentificationCardBack: 0,
        RentalContract: 0,
      });
    },

    removeVehicle({ commit }, index) {
      commit("REMOVE_VEHICLE", index);
    },
  },
  mutations: {
    SET_PROCEDURE(state, value) {
      state.ModelProcedure = value;
    },

    ADD_RESIDENT(state, value) {
      state.ModelProcedure.Resident.push(value);
    },

    UPDATE_RESIDENT(state, params) {
      state.ModelProcedure.Resident[params.idx] = params.resident;
      state.ModelProcedure.Resident = JSON.parse(JSON.stringify(state.ModelProcedure.Resident))//Para forzar el refresco del modelo
    },

    REMOVE_RESIDENT(state, value) {
      state.ModelProcedure.Resident.splice(value, 1);
    },

    ADD_REFERENCE(state, value) {
      state.ModelProcedure.References.push(value);
    },

    REMOVE_REFERENCE(state, value) {
      state.ModelProcedure.References.splice(value, 1);
    },

    ADD_VEHICLE(state, value) {
      state.ModelProcedure.Vehicles.push(value);
    },

    REMOVE_VEHICLE(state, value) {
      state.ModelProcedure.Vehicles.splice(value, 1);
    },

    UPDATE_PARTNER(state, value) {
      const titular = state.ModelProcedure.Titulars[value];
      state.ModelProcedure.Partner.Name = titular.Name;
      state.ModelProcedure.Partner.LastName = titular.LastName;
      state.ModelProcedure.Partner.DateOfBirth = titular.BirthDay;
      state.ModelProcedure.Partner.IdentificationTypeId =
        titular.IdentificationTypeId;
      state.ModelProcedure.Partner.Identification = titular.Identification;
      state.ModelProcedure.Partner.CUIL = titular.CUIL;
      state.ModelProcedure.Partner.PreviousAddres =
        titular.FormerAddresStreet +
        " " +
        titular.FormerAddresNumber +
        ", " +
        titular.FormerAddresDepartment;
      state.ModelProcedure.Partner.Email = titular.Email;
      state.ModelProcedure.Partner.ContactPhone = titular.Phone;
    },
  },
};

const manage = {
  state: {
    ...rent.state,
    ...sell.state,
    ...procedure.state,
  },
  actions: {
    ...rent.actions,
    ...sell.actions,
    ...procedure.actions,
  },
  mutations: {
    ...rent.mutations,
    ...sell.mutations,
    ...procedure.mutations,
  },
};

export default manage;
